import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';

interface GetLiteImagesPayload {
  studyInstanceUID: string;
}

export const getLiteImages = createAsyncThunk(
  'reports/getLiteImages',
  async (payload: GetLiteImagesPayload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const response = await fetch(
        `${REPORTS.GET_LITE_IMAGES}?studyInstanceUID=${encodeURIComponent(payload.studyInstanceUID)}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData.msg || 'Failed to fetch lite images');
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error as Error);
    }
  }
);
